import { authHeaders } from './auth.js';
import { isRequired } from './consent.js';
/**
 * The visitor's 👍/👎 on one answer (ADR-0102): POST /api/feedback, `none`
 * takes the vote back. Returns 'ok', 'session' (401: earn a new one and send
 * again, once), 'consent' (403 consent_required) or 'error'.
 */
export async function sendFeedback(apiBase, siteKey, session, { threadId, messageId, vote }) {
  let response;
  try {
    response = await fetch(new URL('/api/feedback', apiBase), {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(session ? { 'X-Chat-Session': session } : {}) },
      body: JSON.stringify({ site_key: siteKey, thread_id: threadId, message_id: messageId, vote }),
    });
  } catch {
    return 'error';
  }
  if (response.ok) return 'ok';
  if (response.status === 401) return 'session';
  if (isRequired(response.status, await response.json().catch(() => null))) return 'consent';
  return 'error';
}
